import { useEffect } from 'react';
import { RedirectRequestHandler, AuthorizationNotifier } from '@openid/appauth';
import { NoHashQueryStringUtils } from '../../common/NoHashQueryStringUtils';
import { getIdTokenWithAuthorizationCode, loginWithIdToken } from '../../common/authFunctions';
import { useVisionplannerDetails } from '../../common/queries/useVisionplannerDetails';

const resumeInitationFlow = async ({
  code,
  codeVerifier,
  visionplannerDetails,
}) => {
  const idToken = await getIdTokenWithAuthorizationCode({
    code,
    codeVerifier,
    clientId: visionplannerDetails.clientId,
  });
  loginWithIdToken({
    authorizationServerUrl: visionplannerDetails.authorizationServerUrl,
    idToken,
    redirectUrl: visionplannerDetails.visionplannerUrl,
    openInNewWindow: true,
  });
};

/**
 * The component that will be mounted on the return URL when authenticating at the VPC
 * authorization server. This component doesn't render a UI, but redirects the user to
 * the application root, and opens VPC in a new tab whenever the authentication flow succeeds.
 */
export const VPCAuthorizationCallback = () => {
  const useVisionPlannerDetailsQuery = useVisionplannerDetails();
  const authorizationServerUrl = useVisionPlannerDetailsQuery?.data?.authorizationServerUrl;

  useEffect(() => {
    if (!authorizationServerUrl) {
      // the URL of the authorization server hasn't been loaded yet.
      return;
    }

    const authorizationHandler = new RedirectRequestHandler(
      undefined,
      new NoHashQueryStringUtils(),
    );

    const notifier = new AuthorizationNotifier();
    notifier.setAuthorizationListener((request, response, error) => {
      if (error) {
        console.error(error);
        return;
      }

      const { code_verifier: codeVerifier } = request.internal;
      resumeInitationFlow({
        code: response.code,
        codeVerifier,
        visionplannerDetails: useVisionPlannerDetailsQuery?.data,
      }).catch(console.error);
    });

    authorizationHandler.setAuthorizationNotifier(notifier);

    authorizationHandler.completeAuthorizationRequestIfPossible().then(
      console.log,
      console.error,
    );
  }, [authorizationServerUrl, useVisionPlannerDetailsQuery?.data]);
  return null;
};
